/**
 * PlanBadge — the current tier chip (topbar / settings / paywall surfaces).
 * Warn/danger tints ride the subscription status, not the tier name: a paid
 * tier in grace renders alarming, a free tier renders neutral.
 */
import { useBillingLabels } from "../strings";

export interface PlanBadgeProps {
  tier: string | null | undefined;
  status?: string | null;
}

export function PlanBadge({ tier, status }: PlanBadgeProps) {
  const labels = useBillingLabels();
  const text = !tier || tier === "free" ? labels.planFree : labels.planTier(tier);
  const variant =
    status === "past_due" || status === "grace"
      ? " suite-billing-badge--danger"
      : status === "paused" || status === "trialing"
        ? " suite-billing-badge--warn"
        : "";
  return <span className={`suite-billing-badge${variant}`}>{text}</span>;
}
